import { ArrowRight, Play } from "lucide-react";
import { SITE, HERO_IMAGE } from "../data/site";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center spotlight-flicker"
        style={{ backgroundImage: `url(${HERO_IMAGE})`, backgroundPosition: "center 35%" }}
        aria-hidden="true"
      />
      {/* Gradient overlays */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,10,12,0.55) 0%, rgba(10,10,12,0.15) 30%, rgba(10,10,12,0.55) 70%, #0A0A0C 100%)",
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 30%, rgba(212,175,55,0.08) 0%, transparent 55%)",
        }}
        aria-hidden="true"
      />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        <div className="flex-1 flex items-center">
          <div className="max-w-7xl w-full mx-auto px-6 sm:px-8 md:px-12 pt-32 pb-20">
            <div className="max-w-3xl">
              <div className="overline mb-8 text-[#D4AF37]" data-testid="hero-overline">
                Actor · Performer · Saskatchewan
              </div>
              <h1
                data-testid="hero-name"
                className="font-serif-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] leading-[0.95] tracking-tight"
              >
                Isaiah
                <br />
                <span className="italic font-light text-[#F2F2F2]/95">Artavia</span>
                <span className="text-[#991B1B]">.</span>
              </h1>

              <p
                data-testid="hero-tagline"
                className="font-serif-display italic text-2xl sm:text-3xl text-[#D4AF37] mt-8 max-w-xl"
              >
                {SITE.tagline}
              </p>

              <p
                data-testid="hero-intro"
                className="mt-8 max-w-xl text-[#A0A0A8] text-base sm:text-lg leading-relaxed"
              >
                {SITE.intro}
              </p>

              <div className="mt-12 flex flex-wrap items-center gap-4">
                <button
                  data-testid="hero-watch-reel-btn"
                  onClick={() => scrollTo("reel")}
                  className="btn-cine"
                >
                  <Play size={14} fill="currentColor" />
                  Watch the Reel
                </button>
                <button
                  data-testid="hero-contact-btn"
                  onClick={() => scrollTo("contact")}
                  className="btn-ghost"
                >
                  Get in Touch
                  <ArrowRight size={14} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="relative z-10 border-t border-white/5 backdrop-blur-sm bg-black/20">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-6 flex items-center justify-between flex-wrap gap-4">
            <div className="overline text-[#A0A0A8]">Now Booking · 2025 / 2026</div>
            <div className="flex items-center gap-8 text-xs tracking-[0.2em] uppercase text-[#A0A0A8]">
              {SITE.stats.map((s) => (
                <div key={s.label} className="flex items-baseline gap-2">
                  <span className="text-white font-medium">{s.value}</span>
                  <span className="text-[#6B6B72]">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
